import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import { productTypes as allProductTypes } from '@finect/front-resources/Products';
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
export var productTypes = arrayOfObjectsToObject(Object.values(allProductTypes), 'id', 'singular');
export var securityTypes = Object.values(allProductTypes).filter(function (_ref) {
  var category = _ref.category;
  return ['iic', 'stock'].includes(category);
}).map(function (_ref2) {
  var id = _ref2.id;
  return id;
});